module.exports = __webpack_public_path__ + "static/media/map-pin-external.cc9dff10.svg";